var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1030,
    height: 1030,
    viewBox: "0 0 1030 1030",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M515 102.598V337.969M515 692.031V921.367M102.598 515H335.957M690.02 515H925.391M376.191 150.879L420.449 197.148V368.145M609.551 368.145V197.148L653.809 150.879M609.551 675.938V850.957L653.809 897.227M376.191 895.215L420.449 850.957V675.938M370.156 617.598H195.137L144.844 661.855M669.902 617.598H838.887L885.156 661.855M669.902 428.496H832.852L875.098 388.262M358.086 428.496H187.09L144.844 386.25M305.781 309.805L386.25 382.227M716.172 307.793L633.691 386.25M732.266 732.266L643.75 635.703M297.734 730.254L392.285 639.727",
    stroke: "url(#paint0_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 56.3281,
    r: 46.2695,
    stroke: "url(#paint1_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 973.672,
    r: 46.2695,
    stroke: "url(#paint2_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 973.672,
    cy: 515,
    r: 46.2695,
    stroke: "url(#paint3_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3281,
    cy: 515,
    r: 46.2695,
    stroke: "url(#paint4_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.656,
    cy: 354.062,
    r: 42.2461,
    stroke: "url(#paint5_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.656,
    cy: 688.008,
    r: 42.2461,
    stroke: "url(#paint6_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 905.273,
    cy: 354.062,
    r: 42.2461,
    stroke: "url(#paint7_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 917.344,
    cy: 688.008,
    r: 42.2461,
    stroke: "url(#paint8_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.984,
    cy: 925.391,
    r: 38.2227,
    stroke: "url(#paint9_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.016,
    cy: 925.391,
    r: 38.2227,
    stroke: "url(#paint10_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 683.984,
    cy: 120.703,
    r: 38.2227,
    stroke: "url(#paint11_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.016,
    cy: 120.703,
    r: 38.2227,
    stroke: "url(#paint12_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 764.453,
    cy: 768.477,
    r: 46.2695,
    stroke: "url(#paint13_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.547,
    cy: 768.477,
    r: 46.2695,
    stroke: "url(#paint14_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 752.383,
    cy: 273.594,
    r: 46.2695,
    stroke: "url(#paint15_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.57,
    cy: 273.594,
    r: 46.2695,
    stroke: "url(#paint16_linear_14_295)",
    strokeWidth: 20.1172
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 515,
    cy: 515,
    r: 181.055,
    stroke: "url(#paint17_linear_14_295)",
    strokeWidth: 24.1406
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605.527 577.213L550.221 567.18C545.176 557.1 545.176 552.719 545.176 547.067C550.221 542.026 560.264 537.033 560.264 531.993C565.309 516.92 565.309 506.887 565.309 506.887C567.902 503.119 575.352 496.854 575.352 486.774C575.352 476.693 565.309 466.66 565.309 461.667C565.309 421.44 544.799 406.367 515 406.367C486.474 406.367 464.691 421.44 464.691 461.62C464.691 466.66 454.648 476.693 454.648 486.726C454.648 496.76 461.815 503.401 464.691 506.84C464.691 506.84 464.691 516.873 469.736 531.946C469.736 536.986 479.779 541.979 484.824 547.019C484.824 552.06 484.824 557.053 479.779 567.133L424.473 577.213C404.34 582.206 394.297 617.393 394.297 647.539L515 701.025L635.703 647.539C635.703 617.393 625.66 582.206 605.527 577.213Z",
    fill: "url(#paint18_linear_14_295)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_295",
    x1: 513.994,
    y1: 102.598,
    x2: 513.994,
    y2: 921.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_295",
    x1: 515,
    y1: 0,
    x2: 515,
    y2: 112.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_295",
    x1: 515,
    y1: 917.344,
    x2: 515,
    y2: 1030,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_295",
    x1: 973.672,
    y1: 458.672,
    x2: 973.672,
    y2: 571.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_295",
    x1: 56.3281,
    y1: 458.672,
    x2: 56.3281,
    y2: 571.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_295",
    x1: 112.656,
    y1: 301.758,
    x2: 112.656,
    y2: 406.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_295",
    x1: 112.656,
    y1: 635.703,
    x2: 112.656,
    y2: 740.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_295",
    x1: 905.273,
    y1: 301.758,
    x2: 905.273,
    y2: 406.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14_295",
    x1: 917.344,
    y1: 635.703,
    x2: 917.344,
    y2: 740.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14_295",
    x1: 683.984,
    y1: 877.109,
    x2: 683.984,
    y2: 973.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14_295",
    x1: 346.016,
    y1: 877.109,
    x2: 346.016,
    y2: 973.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14_295",
    x1: 683.984,
    y1: 72.4219,
    x2: 683.984,
    y2: 168.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14_295",
    x1: 346.016,
    y1: 72.4219,
    x2: 346.016,
    y2: 168.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14_295",
    x1: 764.453,
    y1: 712.148,
    x2: 764.453,
    y2: 824.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14_295",
    x1: 265.547,
    y1: 712.148,
    x2: 265.547,
    y2: 824.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_14_295",
    x1: 752.383,
    y1: 217.266,
    x2: 752.383,
    y2: 329.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_14_295",
    x1: 269.57,
    y1: 217.266,
    x2: 269.57,
    y2: 329.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_14_295",
    x1: 515,
    y1: 321.875,
    x2: 515,
    y2: 708.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_14_295",
    x1: 515,
    y1: 406.367,
    x2: 515,
    y2: 701.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelAdmin);
export default __webpack_public_path__ + "static/media/ChannelAdmin.174152af11cd496c1dc6f3ce29b864f8.svg";
export { ForwardRef as ReactComponent };